import { useNavigate, useLocation } from "react-router-dom";
import HallImgCarousel from "./HallImgCarousel";
import "./hallCard.scss";
import { addComma } from "@src/utils";

// 개별 홀 아이콘
import timeInterval from '@assets/icons/weddinghall/individual-hall/time-interval.svg';
import lunch from '@assets/icons/weddinghall/individual-hall/lunch.svg';
import flower from '@assets/icons/weddinghall/individual-hall/flower.svg';
import guest from '@assets/icons/weddinghall/individual-hall/guest.svg';
import tableAdult from '@assets/icons/weddinghall/individual-hall/table-adult.svg';
import tableChild from '@assets/icons/weddinghall/individual-hall/table-child.svg';
import venue from '@assets/icons/weddinghall/individual-hall/venue.svg';

type Props = {
  type: "default" | "preview";
  hallData: any;
  compareClassName: any;
  partnerProfileId?: string;
  partnerId: number
};

const HallCard = ({ type, hallData, compareClassName, partnerProfileId, partnerId }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="hallcard-wrap">
      <HallImgCarousel
        type="hall"
        width={window.innerWidth - 40}
        height={217}
        imgs={hallData.images}
        imgClick={() => {
          navigate(`${location.pathname}?tabId=3`);
        }}
      />
      <div className="card-info-wrap">
        <p className={`hallname bold ${compareClassName?.name}`}>{hallData.name}</p>
        <ul className="hallcard-info-list-wrap">
          <li>
            <img src={venue} alt="대관료" width={18} height={18} />
            <span className="hall-card-info-title">대관료</span>
            <b>{hallData.regularPrice.rentalFee ? `${addComma(hallData.regularPrice.rentalFee)}원` : '없음'}</b>
          </li>
          <li>
            <img src={tableAdult} alt="식대" width={18} height={18} />
            <span className="hall-card-info-title">1인 식대</span>
            <b>{addComma(hallData.regularPrice.adultDrinkFee)}원</b>
          </li>
          <li>
            <img src={flower} alt="꽃장식" width={18} height={18} />
            <span className="hall-card-info-title">꽃장식</span>
            <b>{hallData.regularPrice.flowerFee ? `${addComma(hallData.regularPrice.flowerFee)}원` : '대관료에 포함'}</b>
          </li>
          <li>
            <img src={guest} alt="추천인원" width={18} height={18} />
            <span className="hall-card-info-title">보증인원</span>
            <b>
              추천 {hallData.suggestPersonnel}명<br />
              수용 {hallData.capacity}명
            </b>
          </li>
          <li>
            <img src={timeInterval} alt="예식간격" width={18} height={18} />
            <span className="hall-card-info-title">예식 간격·형태</span>
            <b>
              {hallData.weddingGapMinutes.join("분 / ")}분<br />
              {hallData.meals?.[0].ceremonyTypeDescription.replace("예식", "")}
            </b>
          </li>
          <li>
            <img src={lunch} alt="식대" width={18} height={18} />
            <span className="hall-card-info-title">식사형태</span>
            <b>
              {hallData.meals?.[0].typeDescription}
            </b>
          </li>
          {/* <p>
            <span>대관료</span>
            <span>{addComma(hallData.regularPrice.rentalFee)}원</span>
          </p>
          <p>
            <span>식대</span>
            <span>{addComma(hallData.regularPrice.adultDrinkFee)}원</span>
          </p>
          <p>
            <span>예식간격</span>
            <span>{hallData.weddingGapMinutes.join("분, ")}분</span>
          </p>
          <p>
            <span>추천인원</span>
            <span>{hallData.suggestPersonnel}명</span>
          </p> */}
        </ul>
        <button
          className="btn btn-full btn-gray50"
          onClick={() => {
            type === "default"
              ? navigate(`detail/${hallData.uuid}`, { state: partnerId }) : navigate(`/weddinghall/${partnerProfileId}/detail-preview/${hallData.id}`)
          }}
        >
          모두 보기
        </button>
      </div>
    </div>
  );
};

export default HallCard;
